<template>
    <section class="main-section">
        <v-container class="container--large">
            <div class="mb-20px mb-lg-40px">
                <h2 class="tit tit--sm line-height-15 text-center font-weight-regular break-keep">
                    <template v-if="lang === 'ko'">
                        세이지(SAGE)는 <br class="d-lg-none" />
                        <strong>‘지혜롭고 신뢰할 수 있는 동반자’</strong>라는 의미로, <br class="d-none d-lg-block" />
                        <span class="mt-lg-2">변화와 도전을 맞이하여 깊은 통찰과 전문성을 바탕으로 고객의 권익을 지키겠다는 저희의 다짐을 담고 있습니다.</span>
                    </template>
                    <template v-else>
                        SAGE stands for <br class="d-lg-none" />
                        <strong>“a wise and trustworthy companion,”</strong> <br class="d-none d-lg-block" />
                        embodying our unwavering commitment to safeguarding our clients' interests <br class="d-none d-lg-block" />
                        with deep insight and professionalism amid constant change and evolving challenges.
                    </template>
                </h2>
            </div>
            <v-card flat tile width="fit-content" class="border-t border-b text-center mx-auto pa-3 pa-lg-6">
                <p class="txt txt--dark break-keep">
                    <template v-if="lang === 'ko'">세이지는 M&A를 포함한 기업자문 분야와 국내 소송 중심의 분쟁해결 분야에서, 국내외 고객들로부터 높은 신뢰와 평가를 받고 있음을 자부합니다.</template>
                    <template v-else>
                        SAGE is proud to be recognized and trusted by both domestic and international clients for its expertise in corporate advisory services, <br class="d-none d-lg-block" />
                        including M&A, as well as dispute resolution with a focus on domestic litigation.
                    </template>
                </p>
            </v-card>
            <div class="btn-wrap btn-wrap--xl text-center">
                <v-btn x-large outlined color="grey-darken4" :to="lang === 'ko' ? '/firm' : '/en/firm'" class="min-w-120px min-w-lg-160px">
                    <template v-if="lang === 'ko'">더보기</template>
                    <template v-else>Read More</template>
                </v-btn>
            </div>
        </v-container>
    </section>
</template>

<script>
export default {
    props: {
        lang: { type: String, default: "ko" },
    },
};
</script>